import { takeEvery, put, select } from 'redux-saga/effects';
import { get } from 'lodash';
import chatConsts from '../../chatConnection/constants';
import { consts as commentsList } from '../commentsList';
import { consts as notificationCounters } from '../notificationCounters';
import { COMMUNITIES, MY_COMMUNITIES, POST } from '../../../constants/routes';
import { consts as userCommunities } from '../userCommunities';
import { currentLocationSelector } from '../../common/selectors';
import { consts as removeNotificationsCounters } from '../removeNotificationsCounters';
import { consts as postDetails } from '../postDetails';
import { consts as postsList } from '../postsList';

function* newCommentNotificationWorker(action) {
  const message = get(action.payload, 'message');
  const communityId = get(message, 'payload.data.communityId');
  const comment = get(message, 'payload.data.comment');
  const newComment = { ...comment, isNewComment: true };
  const postId = get(comment, 'postId');
  const currentLocation = yield select(currentLocationSelector);
  const isCurrentCommunity = !!currentLocation.match(
    `/${COMMUNITIES}/${communityId}`,
  );
  if (currentLocation === `/${COMMUNITIES}/${MY_COMMUNITIES}`) {
    yield put({
      type: userCommunities.UPDATE_TOTAL_UNREAD_COUNT,
      payload: { communityId },
    });
  } else if (isCurrentCommunity) {
    if (
      currentLocation === `/${COMMUNITIES}/${communityId}/${POST}/${postId}`
    ) {
      yield put({
        type: commentsList.ADD_COMMENT,
        payload: {
          ...newComment,
          parentId: newComment.parentId,
        },
      });

      yield put({
        type: postDetails.ADD_COMMENT,
      });
    }

    yield put({
      type: postsList.POST_COMMENTS_CHANGED,
      payload: {
        postId,
        change: 1,
      },
    });

    yield put({
      type: removeNotificationsCounters.SEND,
      payload: { type: 'communities', community_ids: [communityId] },
    });
  }
  if (!isCurrentCommunity) {
    yield put({
      type: notificationCounters.UPDATE_COMMUNITY_COUNT,
      payload: 1,
    });
  }
}

export default function* newCommentNotificationSaga() {
  yield takeEvery(
    [chatConsts.NEW_POST_COMMENT, chatConsts.NEW_COMMENT_REPLY],
    newCommentNotificationWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/newPostComment.js